import Typography from '@components/v2/ui/Typography/Typography';
import { Box, Grid } from '@mui/material';
import React from 'react';
import { useShallow } from 'zustand/react/shallow';
import { useFeatureFlag } from '../../hooks/useFeatureFlag';
import LangEnum from '../../lang/LangEnum';
import useOrderBookStore from '../../stores/OrderBook/orderBook.store';
import { ActiveOrderTestIds } from '../../utils/testIds/ActiveOrder.testIds';
import { useApplicationContext } from '../context/ApplicationContext/ApplicationContext';
import { useTranslation } from '../translation/TranslationContext';
import { useAbility } from '../users/AbilityContext';
import OrderBookCard from './OrderBookCard';
import OrderTargetList from './OrderTargets/OrderTargetList';
import CustomerSalesOpportunities from './SalesOpportunities/CustomerSalesOpportunities';
import { useOrderBookStyles } from './styles/OrderBookStyles';

const ActiveOrder: React.FC = () => {
  const { translate } = useTranslation();
  const ability = useAbility();
  const selectedOrder = useOrderBookStore(useShallow((state) => state.selectedOrder));
  const isSuggested = selectedOrder?.status === 'SUGGESTED';
  const { isStore } = useApplicationContext();
  const { classes } = useOrderBookStyles();
  const { isEnableOrderBookSalesOpportunity } = useFeatureFlag();
  const showCustomerSalesOpportunities =
    isEnableOrderBookSalesOpportunity &&
    selectedOrder &&
    selectedOrder.customer?.id &&
    !isSuggested &&
    !isStore;
  const isOrderTargetsVisible = !!selectedOrder && !isSuggested && ability.can('read', 'targets');

  return (
    <Grid container spacing={1}>
      <Grid size={12}>
        <Box className={classes.horizontalPadding}>
          <Typography
            variant="overline"
            color="textSecondary"
            gutterBottom
            testId={ActiveOrderTestIds.ACTIVE_SUGGESTED_ORDER_TITLE}
          >
            {translate(LangEnum.ORDER_BOOK_ACTIVE_SUGGESTED_ORDER)}
          </Typography>
        </Box>
      </Grid>
      <Grid size={12}>
        <Box className={classes.horizontalPadding}>
          <OrderBookCard
            activeOrder
            order={selectedOrder}
            testId={ActiveOrderTestIds.ORDER_BOOK_ACTIVE_ORDER_BUTTON}
          />
        </Box>
      </Grid>
      {isOrderTargetsVisible && (
        <Grid size={12}>
          <OrderTargetList
            orderId={selectedOrder.id}
            showLoading={!showCustomerSalesOpportunities}
          />
        </Grid>
      )}
      {showCustomerSalesOpportunities && <CustomerSalesOpportunities order={selectedOrder} />}
    </Grid>
  );
};

export default ActiveOrder;
